import React from "react";
import LegalPage from "@/pages/legal/LegalPage";
import { CONTACT_META, BUSINESS } from "@/pages/legal/_content";
import { RenderText } from "@/components/Footer";
import { Mail, Phone, MapPin, Building2, FileText, Globe } from "lucide-react";

const Contact = () => (
  <LegalPage doc={CONTACT_META} showVersion={false}>
    <section>
      <p>
        We're a small team building CarryIt in India. Reach us any of the ways
        below — for delivery issues the fastest route is the in-app "Get help"
        button on the specific delivery.
      </p>
    </section>

    <div className="grid gap-4 sm:grid-cols-2">
      <div className="rounded-2xl border border-slate-200 bg-white p-5">
        <div className="flex items-center gap-2 text-slate-500 text-xs uppercase tracking-wider mb-2"><Mail className="w-4 h-4"/> Email</div>
        <div className="font-mono text-slate-900"><RenderText text={BUSINESS.email}/></div>
      </div>
      <div className="rounded-2xl border border-slate-200 bg-white p-5">
        <div className="flex items-center gap-2 text-slate-500 text-xs uppercase tracking-wider mb-2"><Globe className="w-4 h-4"/> Website</div>
        <div className="font-mono text-slate-900"><a href={`https://${BUSINESS.website}`} className="hover:underline" target="_blank" rel="noreferrer">{BUSINESS.website}</a></div>
      </div>
      <div className="rounded-2xl border border-slate-200 bg-white p-5">
        <div className="flex items-center gap-2 text-slate-500 text-xs uppercase tracking-wider mb-2"><Phone className="w-4 h-4"/> Phone</div>
        <div className="font-mono text-slate-900"><RenderText text={BUSINESS.phone}/></div>
      </div>
      <div className="rounded-2xl border border-slate-200 bg-white p-5 sm:col-span-2">
        <div className="flex items-center gap-2 text-slate-500 text-xs uppercase tracking-wider mb-2"><MapPin className="w-4 h-4"/> Registered office</div>
        <div className="font-medium text-slate-900"><RenderText text={BUSINESS.legalName}/></div>
        <div className="text-sm text-slate-600 mt-1"><RenderText text={BUSINESS.address}/></div>
      </div>
      <div className="rounded-2xl border border-slate-200 bg-white p-5">
        <div className="flex items-center gap-2 text-slate-500 text-xs uppercase tracking-wider mb-2"><Building2 className="w-4 h-4"/> CIN</div>
        <div className="font-mono text-slate-900"><RenderText text={BUSINESS.cin}/></div>
      </div>
      <div className="rounded-2xl border border-slate-200 bg-white p-5">
        <div className="flex items-center gap-2 text-slate-500 text-xs uppercase tracking-wider mb-2"><FileText className="w-4 h-4"/> GSTIN</div>
        <div className="font-mono text-slate-900"><RenderText text={BUSINESS.gstin}/></div>
      </div>
    </div>

    <section className="pt-4">
      <p className="text-xs text-slate-500">
        For privacy complaints or account concerns, please write to our
        Grievance Officer — details on the /grievance page.
      </p>
    </section>
  </LegalPage>
);

export default Contact;
